export const sanitizeProps = (props, exclude = []) =>
  Object.keys(props)
    .filter((propName) => !exclude.includes(propName))
    .reduce((acc, key) => ({ ...acc, [key]: props[key] }), {})

export const sanitizeFilter = (props, filter = []) =>
  Object.keys(props)
    .filter((propName) => filter.includes(propName))
    .reduce((acc, key) => ({ ...acc, [key]: props[key] }), {})
